export enum TypeSetting {
  THEMATIC,
  VIDEO,
  DOCUMENT,
  COUNTRY,
}
